// ESM wrapper for handlebars
// Dynamically load handlebars as a classic script to avoid UMD/ESM issues

let Handlebars;

const loadHandlebars = () => {
  if (Handlebars) return Promise.resolve(Handlebars);

  return new Promise((resolve, reject) => {
    if (window.Handlebars) {
      Handlebars = window.Handlebars;
      resolve(Handlebars);
      return;
    }

    const script = document.createElement('script');
    script.src = '/node_modules/handlebars/dist/handlebars.js';
    script.onload = () => {
      Handlebars = window.Handlebars;
      resolve(Handlebars);
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

// Immediately load handlebars
await loadHandlebars();

export default Handlebars;
export { Handlebars, loadHandlebars };
